import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Project, ProjectData, ProjectStatus, Company } from 'toolbandi-ui-lib';
import { CrudService, MessageService, SharedDataService, Search } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-projectdata-edit',
	templateUrl: './projectdata-edit.component.html',
	styleUrls: ['./projectdata-edit.component.scss']
})

export class ProjectdataEditComponent implements OnInit, OnDestroy {


	loading: boolean = false;
	projectdata: ProjectData;

	errormessage: any;

	project: Project;
	projectStatus = ProjectStatus;

	consistency = {
		technological_priority: false,
		technological_priority_roadmap: false,
		application_area: false,
		development_application_roadmap: false
	};

	get consistencykeys(): string[] {
		return Object.keys(this.consistency);
	}

	objective = {
		maintenance_consolidation_company_role: false,
		new_market_opportunities_development: false,
		productivity_increase: false,
		other: false,
		othertext: ''
	};

	get objectivekeys(): string[] {
		let keys = Object.keys(this.objective);
		keys = keys.filter(k => k !== 'othertext');
		return keys;
	}

	constructor(
		private projectService: CrudService<Project>,
		private projectdataService: CrudService<ProjectData>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private router: Router
	) { }

	ngOnInit() {
		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			}
		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.projectService.getEntity(Project, 'project', id).subscribe(project => {
			this.project = project;
			const search = new Search('projectdata');
			search.addSimpleFilter('projectid', this.project.id);
			this.projectdataService.searchEntities(ProjectData, 'projectdata', search, search.page).subscribe((pd: ProjectData[]) => {

				if (pd[0]) {
					this.projectdata = pd[0];
					this.projectdata.jsondata = JSON.parse(this.projectdata.jsondata as string);
					if (this.projectdata.jsondata['consistency']) {
						for (const k of this.projectdata.jsondata['consistency']) {
							this.consistency[k] = true;
						}
					}
					if (this.projectdata.jsondata['objective']) {
						for (const k of this.projectdata.jsondata['objective']) {
							this.objective[k] = true;
						}
						if (this.objective.other) {
							this.objective.othertext = this.projectdata.jsondata['otherobjective'];
						}

					}

				} else {
					this.projectdata = new ProjectData();
					this.projectdata.projectid = this.project.id;
				}


				this.loading = false;
			}, ({ error }) => {
				this.messageService.sendError(error, this.translateService.instant('labels.owner'));
				this.project = undefined;
				this.projectdata = undefined;
				this.loading = false;
			});
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.owner'));
			this.project = undefined;
			this.loading = false;
		});

	}

	dismiss(): void {
		this.router.navigateByUrl(`/company/project/view/${this.project.id}#dettagli`);
	}



	submit(): void {
		this.projectdata.jsondata['consistency'] = [];
		for (const k of this.consistencykeys) {
			if (this.consistency[k]) {
				this.projectdata.jsondata['consistency'].push(k);
			} else {
				this.projectdata.jsondata['consistency'] = this.projectdata.jsondata['consistency'].filter(c => c !== k);
			}
		}

		this.projectdata.jsondata['objective'] = [];
		for (const k of this.objectivekeys) {
			if (this.objective[k]) {
				this.projectdata.jsondata['objective'].push(k);
			} else {
				this.projectdata.jsondata['objective'] = this.projectdata.jsondata['objective'].filter(c => c !== k);
			}
		}


		this.projectdata.jsondata['otherobjective'] = this.objective.other ? this.objective.othertext : '';

		const pd = new ProjectData();
		pd.id = this.projectdata.id;
		pd.projectid = this.project.id;
		pd.jsondata = JSON.stringify(this.projectdata.jsondata);


		if (!pd.id) {
			this.projectdataService.createEntity(ProjectData, 'projectdata', pd).subscribe((response: ProjectData) => {
				const messages = this.translateService.instant(['labels.project-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.project-save-success'], messages['labels.success']);
				this.errormessage = undefined;
				this.dismiss();
			}, ({ error }) => {

				if (error.msg) {
					this.errormessage = error.msg;
				} else {
					this.messageService.sendError(
						error.msg ? error.msg : error,
						this.translateService.instant('labels.event-save-error')
					);
					this.errormessage = undefined;
				}

			});
		} else {
			this.projectdataService.saveEntity(ProjectData, 'projectdata', pd).subscribe((response: ProjectData) => {
				const messages = this.translateService.instant(['labels.project-save-success', 'labels.success']);
				this.messageService.sendSuccess(messages['labels.project-save-success'], messages['labels.success']);
				this.errormessage = undefined;
				this.dismiss();
			}, ({ error }) => {

				if (error.msg) {
					this.errormessage = error.msg;
				} else {
					this.messageService.sendError(
						error.msg ? error.msg : error,
						this.translateService.instant('labels.event-save-error')
					);
					this.errormessage = undefined;
				}

			});
		}
	}

}








